// extracted by mini-css-extract-plugin
export default {"Container":"MainLayout_Container__t7djg","PageContainer":"MainLayout_PageContainer__wShdj"};